(function () {
  'use strict';

  function updateThumbOverflowState(scroller) {
    if (!scroller || !scroller.isConnected) return;
    var needsScroll = scroller.scrollWidth > scroller.clientWidth + 2;
    scroller.classList.toggle('product-thumbnails-scroller--no-overflow', !needsScroll);
  }

  function bind(scroller) {
    if (!scroller || scroller.dataset.thumbScrollBound) return;
    scroller.dataset.thumbScrollBound = '1';

    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var moved = false;

    function onMouseMove(e) {
      if (!isDragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 2) {
        moved = true;
        scroller.scrollLeft = scrollStart - dx;
      }
      e.preventDefault();
    }

    function onMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      scroller.classList.remove('is-dragging-thumb-strip');
      if (moved) {
        scroller.dataset.suppressThumbClick = '1';
        window.setTimeout(function () {
          delete scroller.dataset.suppressThumbClick;
        }, 0);
      }
      moved = false;
    }

    scroller.addEventListener(
      'mousedown',
      function (e) {
        if (e.button !== 0) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (scroller.classList.contains('product-thumbnails-scroller--no-overflow')) return;
        isDragging = true;
        moved = false;
        startX = e.clientX;
        scrollStart = scroller.scrollLeft;
        scroller.classList.add('is-dragging-thumb-strip');
        e.preventDefault();
        document.addEventListener('mousemove', onMouseMove, { passive: false });
        document.addEventListener('mouseup', onMouseUp);
      },
      true
    );

    scroller.addEventListener(
      'click',
      function (e) {
        if (scroller.dataset.suppressThumbClick === '1') {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    scroller.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function refreshOverflow() {
      updateThumbOverflowState(scroller);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(refreshOverflow);
      ro.observe(scroller);
    }

    scroller.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', refreshOverflow, { once: true });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshOverflow).catch(function () {});
    }

    requestAnimationFrame(function () {
      refreshOverflow();
      requestAnimationFrame(refreshOverflow);
    });
  }

  if (!window.__productThumbScrollResizeBound) {
    window.__productThumbScrollResizeBound = true;
    window.addEventListener(
      'resize',
      function () {
        document.querySelectorAll('[data-product-thumbnails-scroller]').forEach(updateThumbOverflowState);
      },
      { passive: true }
    );
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-product-thumbnails-scroller]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
